<template>
  <v-form class="user-form" ref="form">
    <v-row>
      <v-col md="4" cols="12">
        <v-text-field
          label="First name"
          :rules="[rules.required]"
          maxlength="50"
          :value="value ? value.firstName : null"
          @input="firstNameInput"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col md="4" cols="12">
        <v-text-field
          label="Last name"
          :rules="[rules.required]"
          maxlength="50"
          :value="value ? value.lastName : null"
          @input="lastNameInput"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { Convert, Rules } from '@itus/ui.common'
import { UserModel } from '@/user-model'

export default {
  name: 'UserForm',
  props: {
    value: {
      type: Object,
      description: "User object"
    },
    mode: {
      type: String,
      description: "Form mode: account, edit, add"
    }
  },
  data() {
    return {
      rules: Rules
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    firstNameInput(newValue) {
      let newData = new UserModel(this.value)
      newData.firstName = Convert.toString(newValue)
      this.$emit('input', newData)
    },
    lastNameInput(newValue) {
      let newData = new UserModel(this.value)
      newData.lastName = Convert.toString(newValue)
      this.$emit('input', newData)
    }
  }
}
</script>